import { render } from "./OCRComponent.vue?vue&type=template&id=2af03a5e&scoped=true"
import script from "./OCRComponent.vue?vue&type=script&lang=ts"
export * from "./OCRComponent.vue?vue&type=script&lang=ts"

import "./OCRComponent.vue?vue&type=style&index=0&id=2af03a5e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2af03a5e"

export default script